// extracted by mini-css-extract-plugin
export default {"section":"IntroductionSection_section__tovRZ","introduction":"IntroductionSection_introduction__5dZXM"};